import { ThemeOptions } from '@mui/material';

import { typography } from 'themeV5/typography';
import { palette } from 'themeV5/palette/dart';

import { breakpoints } from './breakpoints';
import components from './components';

const themeOptions: ThemeOptions = {
  palette: { mode: 'dark', ...palette },
  typography,
  breakpoints,
  components,
  spacing: (factor: number) => `${0.25 * factor}rem`,
};

export default themeOptions;
